import * as yup from 'yup'

export const paymentTermFormValidationSchema = yup.object()
